import { render, staticRenderFns } from "./raiseAQuestion.vue?vue&type=template&id=029ec14c&scoped=true"
import script from "./raiseAQuestion.vue?vue&type=script&lang=js"
export * from "./raiseAQuestion.vue?vue&type=script&lang=js"
import style0 from "./raiseAQuestion.vue?vue&type=style&index=0&id=029ec14c&prod&lang=less&scoped=true"
import style1 from "./raiseAQuestion.vue?vue&type=style&index=1&id=029ec14c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029ec14c",
  null
  
)

export default component.exports